import React, { useState } from 'react';
import t from 'utils/translate';
import SelectInput from '../../shared/components/select-input';
import { MenuItem } from '@mui/material';

function CallAutoAnswerOptions({ initialValue, onChange, isPttCall = false }) {
    const [selectedValue, setSelectedValue] = useState(initialValue);

    const handleChange = (e) => {
        setSelectedValue(e.target.value);
        onChange(e.target.value);
    };

    return (
        <SelectInput value={selectedValue} onChange={handleChange} className="info-field-dropdown">
            <MenuItem value={0}>{t('settings_voip_autoresponse_0')}</MenuItem>
            <MenuItem value={1}>
                {t(isPttCall ? 'settings_voip_ptt_autoresponse_1' : 'settings_voip_autoresponse_1')}
            </MenuItem>
            <MenuItem value={2}>
                {t(isPttCall ? 'settings_voip_ptt_autoresponse_2' : 'settings_voip_autoresponse_2')}
            </MenuItem>
            <MenuItem value={3}>{t('settings_voip_autoresponse_3')}</MenuItem>
        </SelectInput>
    );
}
export default CallAutoAnswerOptions;
